export default __webpack_public_path__ + "static/dmytro-kulakov-7c12ca77eb87e9f8f1dbaaa9400dfb0d.png";